import { Mission } from "@/types/mission/mission-type";
import { MissionsRenderStyled } from "./style-component";
import { MissionComponentProps, MissionsRenderProps } from "./missions-render-types";
import MissionChallenge from "./components/mission/mission-challenge/mission-challenge";
import MissionContest from "./components/mission/mission-contest/mission-contest";

const COMPONENT_MISSION = {
	'CHALLENGE': MissionChallenge,
	'CONTEST': MissionContest,
} as const;

const MissionComponent: React.FC<MissionComponentProps> = ({ mission, participant = [], campaign, requirements }) => {
	const { type } = mission;
	const typeMission = type?.split(':')[0] ?? 'Unknown';
	const AllowedComponent = COMPONENT_MISSION[typeMission as keyof typeof COMPONENT_MISSION] || null;

	if (!AllowedComponent || !Object.keys(COMPONENT_MISSION).includes(typeMission)) {
		return <div style={{ color: 'white' }}>Mission {typeMission} not supported</div>;
	}

	return (
		<AllowedComponent
			mission={mission}
			participant={participant}
			campaign={campaign}
			requirements={requirements}
		/>
	)
}

const MissionsRender: React.FC<MissionsRenderProps> = ({ requirements, missions, participant = [], campaign }) => {
	return (
		<MissionsRenderStyled>
			{missions?.map((mission: Mission) => (
				<MissionComponent
					key={mission.id}
					mission={mission}
					participant={participant}
					campaign={campaign}
					requirements={requirements}
				/>
			))}
		</MissionsRenderStyled>
	);
}

export default MissionsRender
